import useLocalStorage from "@kit/design/use-localstorage"

const PREFIX = "app-discoverability-cta/clicked/"

// Hook to keep track of whether the user has clicked the app discoverability CTA.
// Stores in local storage so the state is persisted across page loads.
export function useClickedPreviously(origin) {
  const key = `${PREFIX}${origin}`
  const [clickedAt, setClickedAt] = useLocalStorage(key, null)
  const setClicked = () => setClickedAt(new Date())

  return [!!clickedAt, setClicked, clickedAt, setClickedAt]
}
